import React from 'react'
import HeaderLinks from './headerLinks/HeaderLinks'
import ScrollingDiv from './ScrollingDiv/ScrollingDiv'

const Home = () => (
  <div>
    <HeaderLinks/>
    <ScrollingDiv/>
  </div>
)

export default Home